import { render } from "./BalIcon.vue?vue&type=template&id=69ad19ff&scoped=true&ts=true"
import script from "./BalIcon.vue?vue&type=script&lang=ts"
export * from "./BalIcon.vue?vue&type=script&lang=ts"

import "./BalIcon.vue?vue&type=style&index=0&id=69ad19ff&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69ad19ff"]])

export default __exports__